.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}
.label {
  font-size: var(--text-sm);
  font-weight: 600;
}
.hint {
  font-size: var(--text-xs);
  color: var(--color-text-muted);
}
.error {
  font-size: var(--text-sm);
  color: var(--color-danger);
}
.control {
  width: 100%;
  min-height: 48px;
  padding: var(--space-3) var(--space-4);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-surface);
  transition: border-color var(--transition);
}
.control:focus {
  outline: none;
  border-color: var(--color-primary);
}
.invalid {
  border-color: var(--color-danger);
}
textarea.control {
  min-height: 120px;
  resize: vertical;
}
.counter {
  align-self: flex-end;
  font-size: var(--text-xs);
  color: var(--color-text-muted);
}
.switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  min-height: 48px;
  cursor: pointer;
}
.switch input {
  appearance: none;
  width: 48px;
  height: 28px;
  flex-shrink: 0;
  border-radius: var(--radius-full);
  background: var(--color-border);
  position: relative;
  cursor: pointer;
  transition: background var(--transition);
}
.switch input::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #fff;
  box-shadow: var(--shadow-sm);
  transition: transform var(--transition);
}
.switch input:checked {
  background: var(--color-help);
}
.switch input:checked::after {
  transform: translateX(20px);
}
select.control {
  appearance: none;
  padding-right: 44px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1.5l5 5 5-5' fill='none' stroke='%23888' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;
}
.passwordWrap {
  position: relative;
}
.withToggle {
  padding-right: 52px;
}
.reveal {
  position: absolute;
  top: 50%;
  right: 4px;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: var(--radius-md);
  background: none;
  display: grid;
  place-items: center;
  color: var(--color-text-muted);
  cursor: pointer;
}
.reveal:hover {
  background: var(--color-surface-2);
}
.reveal:focus-visible {
  outline: 2px solid var(--color-primary);
}
